import type { MonitorSortKey } from '../types/Monitor';
import type { ScalingMode } from '../types/UserMonitorConfig';

// ── App ──────────────────────────────────────────────────────────────────────

export const APP_NAME = 'Monitor Tools';

export const LOCAL_STORAGE_KEY_USER_MONITOR = 'monitor-tools:userMonitor';

// ── Apple Scaling Mode ───────────────────────────────────────────────────────

/**
 * Approximate HiDPI scaling factor per Apple display scaling mode.
 * The true logical resolution for a given monitor depends on its native
 * resolution and the exact presets Apple exposes in System Settings > Displays.
 * These constants are sensible defaults; prefer per-monitor spec data where available.
 */
export const SCALING_FACTORS: Record<ScalingMode, number> = {
  noScaling: 1.0,
  moreSpace: 1.5,
  default:   2.0,
  moreText:  2.5,
};

export const SCALING_MODE_LABELS: Record<ScalingMode, string> = {
  noScaling: 'No Scaling (Native)',
  moreSpace: 'More Space',
  default:   'Default',
  moreText:  'More Text',
};

// ── Filters & Sorting ────────────────────────────────────────────────────────

export const SORT_LABELS: Record<MonitorSortKey, string> = {
  relevance:  'Relevance',
  priceLow:   'Price: Low to High',
  priceHigh:  'Price: High to Low',
  ppi:        'Pixel Density (PPI)',
  sizeLow:    'Size: Small to Large',
  sizeHigh:   'Size: Large to Small',
};

export const PANEL_TYPE_LABELS = {
  IPS:      'IPS',
  VA:       'VA',
  OLED:     'OLED',
  'Mini-LED': 'Mini-LED',
  TN:       'TN',
} as const;

// ── Preview ──────────────────────────────────────────────────────────────────

/** Height of the macOS menu bar in logical pixels */
export const MACOS_MENUBAR_HEIGHT_PX = 30;

/** Height of the macOS Dock in logical pixels (default medium size) */
export const MACOS_DOCK_HEIGHT_PX = 70;
